// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3ag3S","tab":"Tabs_tab__2GFTc","tabActive":"Tabs_tabActive__4LJM3"};